import { render, staticRenderFns } from "./PropertyTypes.vue?vue&type=template&id=54bf51bf&"
import script from "./PropertyTypes.vue?vue&type=script&lang=ts&"
export * from "./PropertyTypes.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyTypes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports